// @ts-nocheck
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SportsManagement from '@/components/admin-dashboard/SportsManagement';
import PositionsManagement from '@/components/admin-dashboard/PositionsManagement';
import SportStatDefinitionsManagement from '@/components/admin-dashboard/SportStatDefinitionsManagement';

const ProfileFeaturesManagement: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Profile Features Management</h1>
        <p className="text-gray-600">Manage sports, positions, and other profile-related data</p>
      </div>

      <Card>
        <CardContent className="p-6">
          <Tabs defaultValue="sports" className="w-full">
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="sports">Sports</TabsTrigger>
              <TabsTrigger value="positions">Positions</TabsTrigger>
              <TabsTrigger value="stat-definitions">Stat Definitions</TabsTrigger>
            </TabsList>
            
            <TabsContent value="sports" className="mt-6">
              <SportsManagement />
            </TabsContent>
            
            <TabsContent value="positions" className="mt-6">
              <PositionsManagement />
            </TabsContent>
            
            <TabsContent value="stat-definitions" className="mt-6">
              <SportStatDefinitionsManagement />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProfileFeaturesManagement;
